<template>
  <div class="mt20" :key="i18nUpdateKey">
    <div class="flex-a-b-c">
      <div class="flex-c-c">
        <el-date-picker
          class="w300"
          v-model="createTime"
          type="daterange"
          :start-placeholder="$t('business', 'startDate')"
          :end-placeholder="$t('business', 'endDate')">
        </el-date-picker>
        <el-button
          class="v-primary ml10"
          type="primary"
          @click="queryAppointmentPage"
          >{{ $t('business', 'query') }}</el-button
        >
      </div>
      <el-button
          
          class="v-primary ml10"
          type="primary"
          @click="addForm"
          >{{ $t('business', 'publishForm') }}</el-button
        >
    </div>

    <commonTable
      :tableData="tableData"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :loading="loading"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column prop="title" align="center" :label="$t('business', 'formName')" />
        <el-table-column prop="pubTime" align="center" :label="$t('business', 'publishTime')" />
        <el-table-column prop="endTime" align="center" :label="$t('business', 'endTime')" />
        <el-table-column prop="feedbackNum" align="center" :label="$t('business', 'feedbackCount')"/>
        
        <el-table-column prop="state" align="center" :label="$t('business', 'operation')">
          <template slot-scope="scope"
            ><span
              style="color: #51cbcd; cursor: pointer;margin-right:10px"
              @click="detall_tap(scope.row.advancedFormId)"
                          >
               {{ $t('business', 'feedbackDetail') }}
              </span>
              <span
                style="color: #51cbcd; cursor: pointer;margin-right:10px"
                @click="editForm(scope.row.advancedFormId)"
              >
               {{ $t('business', 'edit') }}
              </span>
              <span
                style="cursor: pointer"
                :class="scope.row.status == 1 ? 'corange' : 'cblue'"
                @click="updateStatus(scope.row)"
              >
               {{scope.row.status == 1 ? $t('business', 'offline') : $t('business', 'online')}}
              </span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { mapState } from 'vuex';
import {
  updateAdvancedFormStatus,
  fetchProductsTypeList,
  queryPageAdvancedForm
} from "@/api/companyManage.js";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "appointmentList",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      value: "",
      optionList: [], //全部分类
      tableData: [],
      total: 0, //总条数
      currentPage: 1, //当前页数
      queryDate: "",
      pageNum: 1,
      pageSize: 10,
      loading: false, //加载中
      createTime:'',
      start: '',
      end: '',
      jurisdiction:''
    };
  },
  computed: {
    ...mapState(['routerArr']),
    userInfo() {
      return this.$store.state.loginRoot.userInfo;
    }
  },
  watch:{
    routerArr(val){
      
      this.jurisdiction = val.includes("022")
      console.log(val.includes("022"),'this.jurisdiction')
      console.log(this.jurisdiction,'this.jurisdiction')
    },
    createTime(val,old){
      this.start =  getDataTimeSec(this.createTime[0], 'yy-mm-dd') +" 00:00:00"
      this.end = getDataTimeSec(this.createTime[1], 'yy-mm-dd') +" 23:59:59" 
      
      console.log(this.end)
    },
    
  },

  mounted() {
    this.getTableData();
    this.getTypeList();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  methods: {
    //请求预约数据
    getTableData() {
      this.loading = true;
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime:this.start || '',
        endTime:this.end || ''
      };
      queryPageAdvancedForm(data)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.pageInfo.list || [];
          this.total = res.data.pageInfo.total;
        })
        .catch((err) => {
          this.loading = false;
          this.tableData = [];
          console.log(err);
        });
    },
    //查询分类
    getTypeList() {
      fetchProductsTypeList({ ignore: true })
        .then((res) => {
          this.optionList = res.data || [];
        })
        .catch((err) => {
          this.optionList = [];
          console.log(err);
        });
    },
    //筛选查询符合条件数据
    queryAppointmentPage() {
      this.currentPage = 1;
      this.pageNum = 1;
      this.getTableData();
      
    },
    //新增表单
    addForm(){
      if(this.jurisdiction || this.userInfo.roleId){
        console.log(this.jurisdiction,'this.jurisdiction')
        this.$router.push(`/publishAdvancedForm`);
      }else{
        this.$message({
            type: "warning",
            message: this.$t('business', 'noPermission'),
          });
        return
      }
    },
    //编辑表单
    editForm(id){
      if(this.jurisdiction || this.userInfo.roleId){
        console.log(this.jurisdiction,'this.jurisdiction')
        this.$router.push({ path:`/publishAdvancedForm?id=${id}` });
        
      }else{
        this.$message({
            type: "warning",
            message: this.$t('business', 'noPermission'),
          });
        return
      }
      // if(!this.userInfo.roleId){
      //   this.$message({
      //     type: "warning",
      //     message: "无操作权限",
      //   });
      //   return
      // }
      
    },
    //详情按钮
    detall_tap(id){
      // this.$router.push({
      //   name:'formDetall',
      //   params:{
      //     id:id
      //   }
      // });
      this.$router.push({ path:`/formDetall?id=${id}` });
    },
    //筛选时间
    dateChange(val) {
      this.queryDate = getDataTimeSec(val, "yy-mm-dd");
    },
    //取消
    cancel(val) {
      this.$prompt(this.$t('business', 'cancelReason'), this.$t('common', 'info'), {
        confirmButtonText: this.$t('business', 'confirm'),
        cancelButtonText: this.$t('business', 'cancel'),
      })
        .then(({ value }) => {
          let data = {
            appointmentId: val.appointmentId,
            state: 4,
            applyRemark: value,
          };
          this.changeOrderState(data);
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: this.$t('business', 'cancelInput'),
          });
        });
    },
    //确认
    updateStatus(val) {
      if(this.jurisdiction || this.userInfo.roleId){
        this.$confirm( val.status == 0 ? this.$t('business', 'publishFormConfirm') : this.$t('business', 'offlineFormConfirm'), this.$t('common', 'info'), {
          confirmButtonText: this.$t('business', 'confirm'),
          cancelButtonText: this.$t('business', 'cancel'),
          type: "warning",
        })
        .then(() => {
          let data = {
                advancedFormId : val.advancedFormId,
                status : val.status == 1 ? 0 : 1
              }
          this.changeOrderState(data);
          })
          .catch(() => {});
      }else{
        this.$message({
            type: "warning",
            message: this.$t('business', 'noPermission'),
          });
        return
      }
      
    },
    // 修改订单状态
    changeOrderState(params) {
      updateAdvancedFormStatus(params)
      .then((res) => {
        this.$message({
          type: "success",
          message: this.$t('business', 'operationSuccess'),
        });

        this.getTableData();
      })
      .catch((err)=>{
        if(err.code == 201){
          this.$message({
            type: "warning",
            message: err.message,
          });
        }
        

      });
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.getTableData();
    },
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  }
};
</script>

<style lang="scss" scoped>

</style>